'use client';

import { usePublishEvent } from '@/analytics/usePublishEvent';
import { MouseEventHandler } from 'react';

export const useClickWithAnalytics = <T extends HTMLElement>(
  eventName: string,
  onClick?: MouseEventHandler<T>,
): MouseEventHandler<T> => {
  const publishEvent = usePublishEvent();

  return (event) => {
    onClick?.(event);

    const id =
      event.currentTarget.id ||
      event.currentTarget.getAttribute('data-testid') ||
      'unknown';

    publishEvent(eventName, id);
  };
};
